import React from 'react'
import PropTypes from 'prop-types'
import { SkeletonAvatar, SkeletonCard, SkeletonText } from '@offerzen/pinata-shame'

import SceneLayout from '../../components/SceneLayout'

import styles from './styles'

const LoadingScene = ({ showNav }) => (
  <SceneLayout showNav={showNav}>
    <p className={styles.accessiblyHidden}>Loading</p>
    <SkeletonCard className={styles.card}>
      <SkeletonAvatar size="extraLarge" theme="dark" />

      <div className={styles.content}>
        <SkeletonText theme="dark" width={100} />
        <SkeletonText theme="dark" width={120} />
        <SkeletonText theme="dark" width={170} />
        <SkeletonText theme="dark" width={130} />
        <SkeletonText theme="dark" width={80} />
      </div>
    </SkeletonCard>
  </SceneLayout>
)

LoadingScene.propTypes = {
  showNav: PropTypes.bool,
}

export default LoadingScene
